import { ErrorMessageWrapper } from "@/common/components/ErrorMessageWrapper";
import { ShowHeader } from "@/common/components/ShowHeader";
import Tabs from "@/common/components/Tabs";
import { useParams } from "react-router-dom";
import { billingBillTabs } from "../../constants/tabs.constant";
import useBillingBill from "@/features/billingBills/hooks/useBillingBill";
import { useMineCompany } from '@/features/company/hooks/useMineCompany';
import { Tooltip } from "react-tooltip";
import BillDateTitleWithTimezone from "@/common/components/BillDateTitleWithTImezone";
import BillHeaderDropdownActions from "../../components/HeaderDropdownActions";


const BillingBillsShow = () => {
  const { id } = useParams();

  const { data: company } = useMineCompany();

  const {
    data: bill,
    isPending: billIsPending,
    error: billError = {} as any,
    refetch: billRefetch,
  } = useBillingBill({ id });

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-64px)]"
      statusCode={billError?.status}
      refetchFunction={billRefetch}
    >
      <div>
        <ShowHeader
          goBack
          goBackProps={{
            fallback: '/billing-bills',
            searchLastRouteFromReference: `/billing-bills/${id}`,
          }}
          title={
            <div className='flex items-center gap-1'>
              <p data-tooltip-id='branch-tooltip' className="text-nowrap max-w-72 overflow-hidden text-ellipsis font-normal">
                {bill?.client_branch?.display_name}
              </p>

              <Tooltip id="branch-tooltip">
                <p>
                  {bill?.client_branch?.display_name}
                </p>
              </Tooltip>
            </div>
          }
          isLoading={billIsPending}
          titleClassName="text-md"
          subtitle={(
            <div className='flex items-center gap-1 flex-wrap'>
              <p>
                Fatura {bill?.number}
              </p>

              <BillDateTitleWithTimezone
                startDate={bill?.opened_at}
                endDate={bill?.closed_at}
                timezone={bill?.time_zone}
              />
            </div>
          )}
          subtitleClassName="text-nowrap font-medium"
          buttons={(
            <BillHeaderDropdownActions
              bill={bill}
              company={company}
            />
          )}
        />

        <Tabs
          tabsListClassName="w-full bg-transparent rounded-none"
          tabsTriggerClassName="h-8 w-full rounded-none border-b border-[#444444] text-white-800 text-xs data-[state=active]:bg-transparent data-[state=active]:text-white-800 data-[state=active]:shadow-none data-[state=active]:border-blue-800"
          tabsContentClassName="mt-6"
          tabsList={billingBillTabs({ needSupplyAuthorization: company?.kind !== 'private_company' && bill?.need_supply_authorization })}
        />
      </div>
    </ErrorMessageWrapper>
  );
};

export default BillingBillsShow;
